import { useTheme } from 'styled-components';
import { ReturnMetricEnum } from '../../../../models/enums/return-metric-enum';

export {
    RETURN_METRIC_LABELS,
    RETURN_METRIC_STORAGE_KEYS,
    getSeriesIdForMetric,
    getBaseSeriesId,
    getStoredReturnMetric,
} from '../../../../models/constants/return-metric';

export const useReturnMetricColors = () => {
    const theme = useTheme();

    return {
        [ReturnMetricEnum.SimpleReturn]: theme.palette.color.secondary.main,
        [ReturnMetricEnum.TimeWeightedReturn]: theme.palette.color.primary.main,
        [ReturnMetricEnum.MoneyWeightedReturn]: theme.palette.color.positive.main,
    } as const;
};
